/**
 * Shared typography for a field label. `Input` / `Select` / `Textarea` /
 * `Checkbox` / `Combobox` / `MultiCombobox` / `MultiSelect` compose it with
 * the label's colour class; `FieldLabelSpacer` reuses it directly so the
 * spacer can never drift out of step with the real label it stands in for.
 */
export const FIELD_LABEL_TYPOGRAPHY = 'text-sm font-medium';
